export const SET_ZONE_TYPE = 'SET_ZONE_TYPE';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_ZONE_MODAL = 'SET_ZONE_MODAL';
export const SET_STATE = 'SET_STATE';
export const SET_DISTRICT_BY_ZONE = 'SET_DISTRICT_BY_ZONE';
export const SET_DISTRICT_BY_STATE = 'SET_DISTRICT_BY_STATE';
export const SET_ZONE_BY_ZONE_ID = 'SET_ZONE_BY_ZONE_ID';
export const SET_HEALTH_BLOCK_BY_ID = 'SET_HEALTH_BLOCK_BY_ID';
export const SET_VILLAGE_BY_BLOCK_ID='SET_VILLAGE_BY_BLOCK_ID';
export const SET_WARD_BY_ULB_ID='SET_WARD_BY_ULB_ID';
export const SET_SUB_DISTRICT='SET_SUB_DISTRICT';
export const SET_BLOCK ='SET_BLOCK';
export const SET_ULB='SET_ULB';
export const SET_ZONE ='SET_ZONE';
export const SET_VILLAGE='SET_VILLAGE';
export const SET_WARD='SET_WARD';
export const SET_SUB_DISTRICT_BY_DISTRICT='SET_SUB_DISTRICT_BY_DISTRICT';
export const SET_ULB_BY_STATE='SET_ULB_BY_STATE';
export const SET_BLOCK_BY_DISTRICT='SET_BLOCK_BY_DISTRICT';
